import React from "react";
import { createBottomTabNavigator } from "@react-navigation/bottom-tabs";
import { MaterialCommunityIcons, Fontisto } from "@expo/vector-icons";

//import AccountNavigator from "./AccountNavigator";
 import FeedNavigator from "./FeedNavigator";
// import ListingEditScreen from "../screens/ListingEditScreen";
// import NewListingButton from "./NewListingButton";
// import routes from "./routes";
// import navigation from "./rootNavigation";
// import useNotifications from "../hooks/useNotifications";
import SearchUserNavigator from "./SearchUserNavigator";
import ShareNavigator from "./ShareNavigator";
import NotificationNavigator from "./NotificatioNavigator";
const Tab = createBottomTabNavigator();

const AppNavigator = () => {
   // useNotifications();
 
  return (
    <Tab.Navigator>
      {/* <Tab.Screen
        name="Feed"
        component={BuscadorFeed}
        options={{
          tabBarIcon: ({ color, size }) => (
            <Fontisto name="earth" color={color} size={size} />
          ),
          headerShown: false
        }}
      /> */}
      <Tab.Screen
        name="Inicio"
        component={FeedNavigator}
        options={{
          tabBarIcon: ({ color, size }) => (
            <Fontisto name="earth" color={color} size={size} />
          ),
          headerShown: false
        }}
      />
      {//-------------------------------------------------
      //Sección comen
      //-------------------------------------------------
      }
      {/* <Tab.Screen
        name="Buscar usuario"
        component={SearchUserNavigator}
        options={{
          tabBarIcon: ({ color, size }) => (
            <MaterialCommunityIcons name="account-search-outline" color={color} size={size} />
          ),
          headerShown: false
        }}
      /> */}
{/* 
      <Tab.Screen
        name="Compartir"
        component={ShareNavigator}
        options={{
          tabBarIcon: ({ color, size }) => (
            <MaterialCommunityIcons name="plus-circle" color={color} size={size} />
          ),
          headerShown: false
        }}
      /> */}


{/*       
      <Tab.Screen
        name="Notificaciones"
        component={NotificationNavigator}
        options={{
          tabBarIcon: ({ color, size }) => (
            <MaterialCommunityIcons name="airballoon" color={color} size={size} />
          ),
          headerShown: false
        }}
      /> */}




      {/* <Tab.Screen
        name="ListingEdit"
        component={ListingEditScreen}
        options={({ navigation }) => ({
          tabBarButton: () => (
            <NewListingButton
              onPress={() => navigation.navigate(routes.LISTING_EDIT)}
            />
          ),
          tabBarIcon: ({ color, size }) => (
            <MaterialCommunityIcons
              name="plus-circle"
              color={color}
              size={size}
            />
          ),
        })}
      /> */}
      {/* <Tab.Screen
        name="Account"
        component={AccountNavigator}
        options={{
          tabBarIcon: ({ color, size }) => (
            <MaterialCommunityIcons name="account" color={color} size={size} />
          ),
        }}
      /> */}
    </Tab.Navigator>
  );
};

export default AppNavigator;
